<template>
  <div
    :class="{
      'sidebar-item-selected-merchant': true,
      'sidebar-item-selected-merchant--clickable': subMerchantAccounts.length,
      'sidebar-item-selected-merchant--active': showSubMerchantAccounts,
    }"
    @click="$emit('click')"
  >
    <div v-if="isCollapsed" class="sidebar-item-selected-merchant__collapsed">
      <svg-icon icon-class="sidebar-select-merchant" />
    </div>
    <div v-else class="sidebar-item-selected-merchant__merchant-info">
      <div>
        <el-tooltip placement="bottom" :content="activeSubMerchantName">
          <div class="ellipsis">
            <span class="merchant-info__merchant-name tamara-english-medium-3">
              {{ ellipsisEnd(activeSubMerchantName, 20) }}
            </span>
          </div>
        </el-tooltip>
      </div>
      <div
        v-if="merchantProfile.merchantCode"
        class="merchant-info__merchant-id"
      >
        {{ $t('sidebar_id') }}:
        <div dir="ltr" class="merchant-info__merchant-id__text">
          <span class="merchant_code tamara-english-regular-4">
            {{ merchantProfile.merchantCode }}
          </span>
          <svg-icon
            icon-class="copy-solid"
            @mouseover.stop="hoverCopyIcon = true"
            @mouseleave.stop="hoverCopyIcon = false"
            @click.stop="copyMerchantCode(merchantProfile.merchantCode)"
          />
        </div>
      </div>
    </div>

    <div
      v-if="subMerchantAccounts.length"
      class="sidebar-item-selected-merchant__suffix-icon"
      :class="{ 'hover-copy-icon': hoverCopyIcon }"
    >
      <svg-icon
        v-if="showSubMerchantAccounts"
        class="sidebar__change-branch-svg"
        :icon-class="!isCollapsed ? 'chevron-up-down' : 'account-collapsed'"
      />
      <svg-icon
        v-else
        class="sidebar__change-branch-svg"
        :icon-class="!isCollapsed ? 'two-arrows' : 'account-collapsed'"
      />
    </div>
  </div>
</template>

<script>
import { ellipsisEnd } from '@/utils/index.js'
import { getLocalizedValue } from '@/utils/i18n'
import CopyMixin from '@/mixins/copy'
import TrackingEvent from '@/plugins/tracking/event'

export default {
  name: 'SidebarMerchantAccountSelected',
  mixins: [CopyMixin],
  props: {
    showSubMerchantAccounts: {
      type: Boolean,
      default: false,
    },
    merchantProfile: {
      type: Object,
      default: () => ({}),
    },
    subMerchantAccounts: {
      type: Array,
      default: () => [],
    },
    subMerchants: {
      type: Array,
      default: () => [],
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    activeSubMerchantName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hoverCopyIcon: false,
    }
  },
  computed: {
    merchantName() {
      const { merchantName, arMerchantName } = this.merchantProfile
      const enName = merchantName || arMerchantName
      const arName = arMerchantName || merchantName

      return getLocalizedValue(enName, arName)
    },
  },
  methods: {
    ellipsisEnd,
    async copyMerchantCode(merchantCode) {
      this.$track.event(TrackingEvent.global_navbar_id_copy)
      this.handleCopy(merchantCode)
    },
  },
}
</script>

<style lang="scss" scoped>
$merchant_logo_size: 32px;

.sidebar-item-selected-merchant {
  display: flex;
  align-items: center;
  height: var(--sidebar-merchant-account-height);
  padding: 8px;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.12);
  border-radius: 8px;

  &__collapsed {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    color: var(--tamara-color-content-inverted);
  }

  &__merchant-info {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-inline-start: 10px;

    .merchant-info__merchant-name {
      color: #fff;
      text-align: start;
    }

    .merchant-info__merchant-id {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 10px;
      font-weight: 400;
      line-height: 16px;
      color: #e5e5e5;
      text-align: start;

      &__text {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: var(--tamara-color-content-inverted);
      }

      svg {
        margin-inline-start: 4px;
        font-size: 16px;
        color: #ccc !important;
        cursor: pointer;

        &:hover {
          color: #fff !important;
        }
      }

      [dir='rtl'] & {
        .merchant-info__merchant-id__text {
          flex-direction: row-reverse;

          svg {
            margin-inline-start: 0;
            margin-inline-end: 4px;
          }
        }
      }
    }
  }

  &__suffix-icon {
    font-size: 20px;
    color: var(--tamara-color-content-inverted);
    cursor: pointer;

    svg {
      color: var(--tamara-color-content-inverted);
    }
  }

  &:hover {
    .sidebar-item-selected-merchant__suffix-icon {
      color: #fff;
      transition: color 0.3s linear;

      &.hover-copy-icon {
        color: #999;
      }
    }
  }
}
</style>
